import { cn } from "@utils";
import { VersionTile, VersionTileTone } from "./change-management-plan";

const toneClassName: Record<VersionTileTone, string> = {
  revision: "border-green-500 bg-green-100 text-green-700",
  routing: "border-blue-400 bg-blue-200 text-blue-900",
  draft: "border-orange-500 bg-orange-50 text-orange-800",
  new: "border-blue-600 bg-blue-100 text-blue-700",
};

export const VersionTileChip = ({ tile }: { tile: VersionTile }) => (
  <span
    className={cn(
      "whitespace-nowrap rounded border border-solid px-1.5 text-xs font-medium leading-[1.66]",
      toneClassName[tile.tone]
    )}
  >
    {tile.label}
  </span>
);
